module.exports = __webpack_public_path__ + "static/media/downloadPrintReport.7b872744.svg";